import storage from '../../helper/storage';
const STORE_CART = 'STORE_CART';
// eslint-disable-next-line no-unused-vars
const STORE_ORDER_PACKAGE = 'STORE_ORDER_PACKAGE';

// initial state
// shape: [{ id, quantity }]
const state = {
    storeCard: []
};

// getters
const getters = {
    storeCard: (state) => {
        return state.storeCard;
    },

    storeCardLen: (state) => {
        return state.storeCard.length;
    },

    storeCardTotal: (state, getters) => {
        if (getters.storeCardLen == 0) {
            return 0;
        }
        return state.storeCard.map(m => m.payPrice).reduce((prev, next) => prev + next);
    }
};

// mutations
const mutations = {
    setStoreCart(state, change) {
        state.storeCard = change;
        storage.set(STORE_CART, change);
    }
};

// actions
const actions = {
    queryStoreCart({ commit }) {
        let sc = storage.get(STORE_CART);
        if (!sc) {
            sc = [];
        } else {
            sc = JSON.parse(sc);
        }
        commit('setStoreCart', sc);
    },
    /**
     * 清除购物车 & 待支付信息
     * @param {*} param0
     */
    clearStoreCart({ commit }) {
        console.log('clearStoreCart');
        commit('setStoreCart', []);
        // 清除本地存储
        storage.remove('STORE_CART');
        storage.remove('STORE_ORDER_PACKAGE');
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
